import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./home.js";
import PatientsRegister from "./patients/PatientsRegister";
import ProviderRegister from "./providers/ProviderRegister";
import PatientsList from "./patients/PatientsList";
import Roles from "./security/Roles";
import Users from "./security/Users";
import RoleEdit from "./security/RoleEdit";
import PatientsRegistration from "./registration/PatientsRegistration";
import LoginFront from "./login/LoginFront";
import MainPatient from "./patient-portal/MainPatient";
import MainProviders from "./provider-portal/MainProviders";
import LoginMain from "./login-providers/LoginMain";
import ProvidersRegistration from "./registration/ProvidersRegistration";
import ProvidersList from "./providers/ProvidersList";
import MainProviderVerification from "./provider-portal/MainProviderVerification";
import PatientEdit from "./patients/PatientEdit";
import MyCalendar from "./providers/MyCalendar";
import PatientAppointment from "./patients/PatientAppointment";
import ForgotPassword from "./providers/ForgotPassword";
import VerificationStep from "./patients/VerificationStep";
import ProviderRecoverPassword from "./providers/ProviderRecoverPassword";
import AppointmentsList from "./patient-portal/AppointmentsList";
import PatientForgotPassword from "./patients/ForgotPassword";
import PatientRecoverPassword from "./patients/PatientRecoverPassword";
import PatientEditProfile from "./patients/PatientEditProfile";
import ProviderEditProfile from "./providers/ProviderEditProfile";
import LobbyPatient from "./patient-portal/LobbyPatient";
import NotFound from "./utils/NotFound";
import LobbyProvider from "./provider-portal/LobbyProvider";
import HealthCareProviders from "./patient-portal/HealthCareProviders";
import Checkout from "./payments/Checkout";
import ProviderServiceSettings from "./providers/ProviderServiceSettings";
import ProviderUserSettings from "./providers/ProviderUserSettings";
import ProviderSetting from "./providers/ProviderSetting";
import VerificationStepProv from "./providers/VerificationStepProv";
import ProviderDetailsFromPatient from "./providers/ProviderDetailsFromPatient";
import ProviderEditFromAdmin from "./providers/ProviderEditFromAdmin";
import Planner from "./planner/Planner";
import TextConsultation from "./patients/TextConsultation";
import ProviderTextConsult from "./providers/ProviderTextConsult";
import InboxPatient from "./patients/InboxPatient";
import UserEdition from "./security/administration/UserEdition";
import ProviderAppointment from "./providers/ProviderAppointment";
import LoginAdministrator from "./administrator/login/LoginAdministrator";
import MainInsights from "./administrator/main/MainInsights";
import UserCreation from "./administrator/registration/UserCreation";
import PatientsAdminList from "./patients/PatientsAdminList";
import OrdersSummary from "./patient-portal/OrdersSummary";

export default function HomeRouter() {
  // const [userData, setUserData] = useState("");
  // const [userProfileImg, setUserProfileImg] = useState({
  //   profileImg: "",
  //   exists: null
  // });
  // const [newUserProfileImg, setNewUserProfileImg] = useState("");
  // const changeUserData = (data) => setUserData(data);
  // const changeUserProfileImg = (data) => setUserProfileImg(data);
  // const changeNewUserProfileImg = (data) => setNewUserProfileImg(data);

  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/about">
          <h1>From About Route</h1>
        </Route>
        <Route exact path="/patient/login">
          <LoginFront />
        </Route>
        <Route exact path="/patient/login/recovery">
          <PatientForgotPassword />
        </Route>
        <Route exact path="/patient/login/recover/:id">
          <PatientRecoverPassword />
        </Route>
        <Route exact path="/patient/editProfile">
          <PatientEditProfile />
        </Route>
        {/* Lobby for Virtual Consultation for Patient */}
        <Route exact path="/patient/lobby">
          <LobbyPatient />
        </Route>
        <Route exact path="/patient/appointments">
          <AppointmentsList />
        </Route>
        <Route exact path="/patient/appointments/create">
          <PatientAppointment />
        </Route>
        <Route exact path="/patient/registration">
          <PatientsRegistration />
        </Route>
        {/* Route for confirm the patient account sended by email, the :id is the Token */}
        <Route exact path="/patient/confirm/:id">
          <VerificationStep />
        </Route>
        <Route exact path="/patient/dashboard">
          <MainPatient />
        </Route>
        <Route exact path="/patient/textconsultation">
          <TextConsultation />
        </Route>
        {/* ROute to access the EHC from Patient Section */}
        <Route exact path="/patient/ehc">
          <MainPatient />
        </Route>

        <Route exact path="/patient/orders">
          <OrdersSummary />
        </Route>

        {/* Inbox patient */}
        <Route exact path="/patient/inbox">
          <InboxPatient />
        </Route>
        <Route exact path="/patient/providers">
          <HealthCareProviders />
        </Route>
        <Route exact path="/admin/login">
          <LoginMain />
        </Route>
        <Route exact path="/admin/dashboard">
          <MainProviders />
        </Route>
        {/* Route Setting for Providers and Admin */}
        <Route exact path="/admin/settings">
          <ProviderSetting />
        </Route>
        <Route exact path="/admin/serviceSettings">
          <ProviderServiceSettings />
        </Route>
        <Route exact path="/admin/userSettings">
          <ProviderUserSettings />
        </Route>
        <Route exact path="/admin/patient/list">
          <PatientsList />
        </Route>
        {/* Route for Edit a Patient */}
        <Route exact path="/admin/patient/edit/:id?">
          <PatientEdit />
        </Route>
        <Route exact path="/admin/calendar">
          <MyCalendar />
        </Route>
        <Route exact path="/admin/newAppointment">
          <ProviderAppointment />
        </Route>
        <Route exact path="/admin/login/recovery">
          <ForgotPassword />
        </Route>
        <Route exact path="/user/login/recover/:id">
          <ProviderRecoverPassword />
        </Route>
        <Route exact path="/admin/newAppointment">
          <ProviderAppointment />
        </Route>

        <Route exact path="/provider/editProfile">
          <ProviderUserSettings />
        </Route>
        <Route path="/patient/provider/details/:id">
          <ProviderDetailsFromPatient />
        </Route>

        <Route exact path="/admin/textconsult">
          <ProviderTextConsult />
        </Route>

        <Route exact path="/admin/patientRegister">
          <PatientsRegister />
        </Route>

        {/* Lobby for Virtual Consultation for Patient */}
        <Route exact path="/admin/provider/lobby">
          <LobbyProvider />
        </Route>
        {/* Route for Provider Registration from Front */}
        <Route exact path="/admin/provider/registration">
          <ProvidersRegistration />
        </Route>
        {/* Route for account confirmation for PROVIDERS */}
        <Route exact path="/admin/provider/confirm/:id">
          <MainProviderVerification />
        </Route>
        {/* Route for Appointment Checkout - Patient */}
        <Route exact path="/patient/checkout/appointment">
          <Checkout />
        </Route>
        <Route exact path="/admin/provider/planner">
          <Planner />
        </Route>

        {/*  ROUTES FOR ADMIN && SPECIAL USERS PORTAL  */}
        <Route exact path="/users/login">
          <LoginAdministrator />
        </Route>
        <Route exact path="/users/home">
          <MainInsights />
        </Route>

        <Route exact path="/users/provider/list">
          <ProvidersList />
        </Route>
        {/* Route for Edit a Provider */}
        <Route exact path="/users/provider/edit/:id?">
          <ProviderEditFromAdmin />
        </Route>
        <Route exact path="/users/providerRegister">
          <ProviderRegister />
        </Route>
        <Route exact path="/users/patient/list">
          <PatientsAdminList />
        </Route>
        <Route exact path="/users/users">
          <Users />
        </Route>
        <Route exact path="/users/role">
          <Roles />
        </Route>

        <Route exact path="/users/role/edit/:id?">
          <RoleEdit />
        </Route>
        <Route exact path="/users/create">
          <UserCreation />
        </Route>
        <Route exact path="/users/edit/:id?">
          <UserEdition />
        </Route>

        {/* Route for 404 NotFound */}
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </Router>
  );
}
